import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";

import './leaders.css'
import Cross from '../../assets/Cross.jpg'

const Beliefs = () => {
    return (
        <Box className="App-header" sx={{backgroundColor: '#006494'}}>
                <Box className='pastor-container' sx={{backgroundColor: 'white', padding: 6}}>
                <Stack direction='row' spacing={24}>
                    <Stack className='pastor-column' spacing={2}>
                        <Typography level='h1'>
                            Beliefs
                        </Typography>
                        <Typography level='h3'>
                            God The King And The Holy Trinity
                        </Typography>
                        <Typography level='body-md'>
                            We believe that God is the Eternal King. He is an infinite, unchangeable Spirit, perfect in
                            holiness, wisdom, goodness, justice, power, and love. From all eternity He exists as the One
                            Living and True God in three persons of one substance, the Father, the Son, and the Holy Spirit,
                            equal in power and glory.
                        </Typography>
                        <Typography level='h3'>
                            God The King: The Creator And Ruler Of All Things
                        </Typography>
                        <Typography level='body-md'>
                            We believe that God’s kingdom is everlasting. From His throne, through His Son, His eternal
                            Word, God created, upholds and governs all that exists: the heavenly places, the angelic hosts,
                            the universe, the earth, every living thing, and human beings. God created all things very good.
                        </Typography>
                        <Typography level='h3'>
                            Counterfeit Kingdom: Satan And Demonic Hosts
                        </Typography>
                        <Typography level='body-md'>
                            We believe that Satan, originally a great, good angel, rebelled against God, taking a host of
                            angels with him. He was cast out of God’s presence and, as a usurper of God’s rule, established
                            a counter-kingdom of darkness and evil on the earth.
                        </Typography>
                        <Typography level='h3'>
                            The Kingdom In Creation, The Fall, And The Doctrine Of Original Sin
                        </Typography>
                        <Typography level='body-md'>
                            We believe that God created mankind in His image, male and female, for relationship with Himself
                            and to govern the earth. Under the temptation of Satan, our original parents fell from grace,
                            bringing sin, sickness, and God’s judgment of death to the earth. Through the fall, Satan and
                            his demonic hosts gained access to God’s good creation. Creation now experiences the
                            consequences and effects of Adam’s original sin. Human beings are born in sin, subject to God’s
                            judgment of death, and captive to Satan’s kingdom of darkness.
                        </Typography>
                        <Typography level='h3'>
                            God’s Providence, Kingdom Law, And Covenants
                        </Typography>
                        <Typography level='body-md'>
                            We believe that God did not abandon His rule over the earth, which He continues to uphold by His
                            providence. In order to bring redemption, God established covenants which revealed His grace to
                            sinful people. In the covenant with Abraham, God bound Himself to His people Israel, promising
                            to deliver them from bondage to sin and Satan and to bless all the nations through them.

                            We believe that as King, God later redeemed His people by His mighty acts from bondage in Egypt
                            and established His covenant through Moses, revealing His perfect will and our obligation to
                            fulfill it. The law’s purpose is to order our fallen race and to make us conscious of our moral
                            responsibility.

                            By the work of God’s Spirit, it convicts us of our sin and God’s righteous judgment against us
                            and brings us to Christ alone for salvation. We believe that when Israel rejected God’s rule
                            over her as King, God established the monarchy in Israel and made an unconditional covenant with
                            David, promising that his heir would restore God’s kingdom and reign over His people as Messiah
                            forever.
                        </Typography>
                        <Typography level='h3'>
                            Christ The Mediator And Eternal King
                        </Typography>
                        <Typography level='body-md'>
                            We believe that in the fullness of time, God honored His covenants with Israel and His prophetic
                            promises of salvation by sending His Son, Jesus, into the world. Conceived by the Holy Spirit
                            and born of the Virgin Mary, as fully God and fully human in one person, He is humanity as God
                            intended us to be. Jesus was anointed as God’s Messiah and empowered by the Holy Spirit,
                            inaugurating God’s kingdom reign on earth, overpowering the reign of Satan by resisting
                            temptation, preaching the good news of salvation, healing the sick, casting out demons, and
                            raising the dead. Gathering His disciples, He reconstituted God’s people as His Church to be the
                            instrument of His kingdom.

                            After dying for the sins of the world, Jesus was raised from the dead on the third day,
                            fulfilling the covenant of blessing given to Abraham. In His sinless, perfect life Jesus met the
                            demands of the law and in His atoning death on the cross He took God’s judgment for sin, which
                            we deserve as law-breakers. By His death on the cross He also disarmed the demonic powers. The
                            covenant with David was fulfilled in Jesus’ birth from David’s house, His Messianic ministry,
                            His glorious resurrection from the dead, His ascent into heaven, and His present rule at the
                            right hand of the Father. As God’s Son and David’s heir, He is the eternal Messiah-King,
                            advancing God’s reign throughout every generation and throughout the whole earth today.
                        </Typography>
                        <Typography level='h3'>
                            The Ministry Of The Holy Spirit
                        </Typography>
                        <Typography level='body-md'>
                            We believe that the Holy Spirit was poured out on the Church at Pentecost in power, baptizing
                            believers into the Body of Christ and releasing the gifts of the Spirit to them. The Spirit
                            brings the permanent indwelling presence of God to us for spiritual worship, personal
                            sanctification, building up the Church, gifting us for ministry, and driving back the kingdom of
                            Satan by the evangelization of the world through proclaiming the word of Jesus and doing the
                            works of Jesus.

                            We believe that the Holy Spirit indwells every believer in Jesus Christ and that He is our
                            abiding Helper, Teacher, and Guide. We believe in the filling or the empowering of the Holy
                            Spirit, often a conscious experience, for ministry today. We believe in the present ministry of
                            the Spirit and in the exercise of all of the biblical gifts of the Spirit. We practice the
                            laying on of hands for the empowering of the Spirit, for healing, and for recognition and
                            empowering of those whom God has ordained to lead and serve the Church.
                        </Typography>
                        <Typography level='h3'>
                            The Sufficiency Of Scripture
                        </Typography>
                        <Typography level='body-md'>
                            We believe that the Holy Spirit inspired the human authors of Holy Scripture so that the Bible
                            is without error in the original manuscripts. We receive the sixty-six books of the Old and New
                            Testaments as our final, absolute authority, the only infallible rule of faith and practice.
                        </Typography>
                        <Typography level='h3'>
                            The Power Of The Gospel Over The Kingdom Of Darkness
                        </Typography>
                        <Typography level='body-md'>
                            We believe that the whole world is under the domination of Satan and that all people are sinners
                            by nature and choice. All people therefore are under God’s just judgment. Through the preaching
                            of the Good News of Jesus and the kingdom of God, and the work of the Holy Spirit, God
                            regenerates, justifies, adopts, and sanctifies, through Jesus by the Spirit, all who repent of
                            their sins and trust in Jesus Christ as Lord and Savior. By this they are released from Satan’s
                            domain and enter into God’s kingdom reign.
                        </Typography>
                        <Typography level='h3'>
                            The Church: Instrument Of The Kingdom
                        </Typography>
                        <Typography level='body-md'>
                            We believe in the one, holy, universal Church. All who repent of their sins and confess Jesus as
                            Lord and Savior are regenerated by the Holy Spirit and form the living Body of Christ, of which
                            He is the head and of which we are all members.
                        </Typography>
                        <Typography level='h3'>
                            Baptism And The Lord’s Supper
                        </Typography>
                        <Typography level='body-md'>
                            We believe that Jesus Christ committed two ordinances to the Church: water baptism and the
                            Lord’s Supper. Both are available to all believers.
                        </Typography>
                        <Typography level='h3'>
                            The Kingdom Of God And The Final Judgment
                        </Typography>
                        <Typography level='body-md'>
                            We believe that God’s kingdom has come in the ministry of our Lord Jesus Christ, that it
                            continues to come in the ministry of the Spirit through the Church, and that it will be
                            consummated in the glorious, visible, and triumphant appearing of Christ – His return to the
                            earth as King. After Christ returns to reign, He will bring about the final defeat of Satan and
                            all of his minions and works, the resurrection of the dead, the final judgment and the eternal
                            blessing of the righteous, and eternal conscious punishment of the wicked. Finally, God will be
                            all in all and His kingdom, His rule and reign, will be fulfilled in the new heavens and the new
                            earth, recreated by His mighty power, in which righteousness dwells and in which He will forever
                            be worshipped.
                        </Typography>
                    </Stack>
                    <Stack className='pastor-column' spacing={2}>
                        <img className='image'
                            src={Cross} alt="Cross"/>
                    </Stack>
                </Stack>
            </Box>
        </Box>
        
    );
};

export default Beliefs;